import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-warm-sand">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6 text-[#005F73]" data-testid="btn-back">
          <ArrowLeft className="w-4 h-4 mr-2" /> Retour
        </Button>

        <h1 className="text-3xl sm:text-4xl font-semibold text-[#005F73] mb-8">Conditions Générales de Vente</h1>

        <div className="space-y-8 text-stone-700 leading-relaxed text-sm sm:text-base">
          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">1. Objet</h2>
            <p>
              Les présentes Conditions Générales de Vente (CGV) régissent l'utilisation du service GwadImmo Invest, accessible depuis le site gwadimmo-invest.com. En souscrivant à un abonnement, l'utilisateur accepte sans réserve les présentes CGV.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">2. Description du service</h2>
            <p>
              GwadImmo Invest est un outil en ligne de simulation et de calcul de rentabilité pour les investissements immobiliers dans les DROM (Guadeloupe, Martinique, Guyane, La Réunion, Mayotte). Le service permet de :
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Calculer la rentabilité brute et nette d'un investissement</li>
              <li>Simuler le financement et les charges associées</li>
              <li>Estimer les avantages fiscaux (Pinel, Girardin)</li>
              <li>Gérer et comparer plusieurs projets immobiliers</li>
              <li>Exporter les résultats en PDF (selon le plan souscrit)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">3. Offres et tarification</h2>
            <p>GwadImmo Invest propose les formules suivantes :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Découverte</strong> : 2,00 EUR (paiement unique) - 1 simulation incluse, calculs complets, visualisations. Non renouvelable.</li>
              <li><strong>Starter</strong> : 4,99 EUR/mois - 5 projets par mois, export PDF</li>
              <li><strong>Professional</strong> : 9,99 EUR/mois - Projets illimités, export PDF, comparaison de projets</li>
            </ul>
            <p className="mt-2">
              Les abonnements payants sont renouvelés automatiquement chaque mois. L'utilisateur peut annuler son abonnement à tout moment depuis la page "Mon compte".
            </p>
            <p className="mt-2">
              Les prix sont indiqués en euros TTC.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">4. Paiement</h2>
            <p>
              Les paiements sont effectués par carte bancaire via la plateforme sécurisée Stripe. L'abonnement est renouvelé automatiquement chaque mois à la date anniversaire de la souscription. Aucune donnée bancaire n'est stockée sur nos serveurs.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">5. Droit de rétractation</h2>
            <p>
              Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux contenus numériques fournis immédiatement après la souscription. L'utilisateur en est informé et l'accepte lors de son achat.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">6. Résiliation</h2>
            <p>
              L'utilisateur peut résilier son abonnement à tout moment depuis la page "Mon compte" de l'application. La résiliation prend effet à la fin de la période en cours. L'accès au service reste actif jusqu'à la fin de la période payée. Pour toute question, contactez-nous à : <a href="mailto:gwadimmo.invest@gmail.com" className="text-[#0A9396] underline">gwadimmo.invest@gmail.com</a>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">7. Limitation de responsabilité</h2>
            <p>
              Les calculs et simulations fournis par GwadImmo Invest sont donnés à titre indicatif uniquement. Ils ne constituent en aucun cas un conseil en investissement financier ou immobilier. L'utilisateur est invité à consulter un professionnel avant toute décision d'investissement. GwadImmo Invest décline toute responsabilité en cas de pertes financières liées à l'utilisation du service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">8. Modification des CGV</h2>
            <p>
              GwadImmo Invest se réserve le droit de modifier les présentes CGV à tout moment. Les utilisateurs seront informés de toute modification par email. L'utilisation continue du service après modification vaut acceptation des nouvelles conditions.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">9. Droit applicable</h2>
            <p>
              Les présentes CGV sont régies par le droit français. En cas de litige, les tribunaux compétents seront ceux du ressort du siège de l'éditeur.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
